import React, {useState, useEffect} from "react";

export default function TrendFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M242.737,482.849c-0.449-9.08-7.408-64.151-7.473-64.697c-0.05-0.438-4.57-43.832-7.479-62.205
 c-1.957-12.338-5.963-28.181-8.178-36.529c-1.47-5.559-2.181-11.298-2.099-17.061c0.142-10.359,0.257-23.517-0.027-27.377
 c-0.131-1.766-0.471-4.236-0.865-7.095c-0.972-7.101-2.306-16.827-1.743-25.032c0.246-3.581,0.859-8.681,1.569-14.579
 c1.569-13.038,3.722-30.887,3.64-47.063c-0.087-18.772,0.897-31.422,1.324-35.992c0.082-0.858,0.24-1.711,0.464-2.537
 c2.149-7.86,11.54-49.538-14.727-97.765l-4.455-8.792l-4.063-17.762l-1.005-1.832c-0.4-0.098-1-0.281-1.624-0.161
 c-25.321,4.756-48.412,10.103-70.595,16.351c-2.996,0.842-5.97,1.656-8.933,2.471c-7.172,1.969-14.59,4.002-21.937,6.352
 c-0.356,0.137-0.596,0.487-0.596,0.869v19.828l0.006-0.005c0.082,3.034,0.606,22.407,1.088,37.96l0.004,0.191l-0.835,1.427
 c-0.832,1.437-1.657,2.881-2.483,4.324c-1.29,2.269-2.569,4.537-3.837,6.817c-1.635,2.941-3.303,5.975-4.953,9.009
 c-1.963,3.618-3.925,7.281-5.827,10.884c-2.182,4.139-4.352,8.325-6.451,12.447c-2.34,4.592-4.641,9.2-6.844,13.705
 c-2.416,4.948-4.768,9.878-6.986,14.651c-2.411,5.182-4.729,10.326-6.889,15.285c-2.323,5.318-4.526,10.572-6.549,15.601
 c-2.191,5.457-4.143,10.562-5.964,15.613c-1.94,5.38-3.624,10.392-5.143,15.323c-1.608,5.21-2.937,10.021-4.073,14.705l-0.148,0.623
 c-1.126,4.652-2.291,9.458-2.727,14.225c-0.23,2.443-0.192,4.909-0.16,7.303c0.012,0.788,0.023,1.58,0.023,2.373l0.011,4.93
 c0.016,4.03,0.027,8.053,0.048,12.076c0.023,4.74,0.05,9.474,0.082,14.208c0.038,5.122,0.082,10.245,0.132,15.367
 c0.055,5.182,0.114,10.37,0.186,15.552c0.082,5.451,0.164,10.278,0.257,14.771c0.103,4.98,0.208,9.113,0.328,13.016
 c0.098,3.039,0.223,6.636,0.421,10.289l0.01,0.218c0.116,2.099,0.23,4.264,0.509,6.385c0.044,0.35,0.093,0.699,0.158,1.05
 c1.957,10.091,1.963,31.017,1.017,39.666c-0.897,8.199,1.225,34.008,1.247,34.269l0.016,0.175l0.159,0.082
 c0.103,0.055,10.151,5.035,26.032,5.035c0.503,0,1.017-0.005,1.53-0.016c15.837-0.317,26.42-0.76,36.965-2.165
 c10.021-1.339,10.759-3.717,10.808-3.985l0.006-0.06c0-0.366,0.126-36.872,1.246-52.54c0.65-9.08,1.214-18.882,1.733-29.951
 c0.366-7.965,0.743-16.46,0.863-25.021c0.05-3.619,0-7.266-0.044-10.786c-0.097-7.647-0.202-15.547,0.717-23.402
 c1.777-15.111,4.866-30.264,7.856-44.914c0.36-1.76,0.721-3.527,1.077-5.287c0.885-4.356,2.285-8.992,5.914-10.687
 c0.651,3.302,5.046,25.754,5.822,32.374c0.777,6.587,5.538,44,6.555,51.927c1.011,7.85,12.819,61.516,12.939,62.062
 c0.093,0.4,9.638,40.044,11.092,56.821c1.476,16.996,4.986,32.488,5.625,33.253c0.459,0.552,8.911,3.1,21.927,3.526
 c1.181,0.039,2.422,0.06,3.733,0.06c12.163,0,29.837-1.891,50.37-9.834l0.213-0.088L242.737,482.849z"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M474.961,255.096c0.087-0.013,0.133-0.02,0.133-0.02h-0.133c-0.025-1.383-0.051-2.773-0.078-4.176
 c0.146-0.022,0.24-0.033,0.262-0.038l-0.099-0.634c-0.017,0-0.076,0.011-0.174,0.027c-0.397-20.939-0.92-43.873-1.421-65.785
 c-0.397-17.507-0.773-34.046-1.045-47.852c-0.479-24.427-2.799-60.331-11.14-92.672c-0.234-0.913-0.424-1.64-0.446-1.826V42.11
 c1.644-11.538-0.833-24.715-1.52-26.919v-0.054h-0.015c-0.055-0.159-0.094-0.246-0.12-0.269l-0.158-0.109l-0.044,0.022
 c-46.1-9.172-90.065-8.685-118.835-6.657c-30.071,2.121-50.248,6.313-51.85,6.651l-0.038-0.016l-0.049,0.039h-0.022v0.011
 l-0.088,0.059c-0.021,0.023-0.065,0.11-0.114,0.269l-0.017,0.054c-0.685,2.204-3.162,15.38-1.524,26.919l0.005,0.011
 c-0.027,0.186-0.212,0.913-0.446,1.826c-8.341,32.347-10.666,68.251-11.145,92.672c-0.267,13.812-0.648,30.351-1.046,47.857
 c-1.432,62.9-3.055,134.195-1.382,142.558c0.822,4.138,0.964,27.547,1.121,54.657c0.261,43.256,0.583,97.093,3.768,105.746
 l0.055,0.148l0.151,0.043c0.306,0.099,31.171,9.401,72.453,0.017c0.294-0.005,0.305-0.208,0.583-5.324
 c0.174-3.197,0.419-7.767,0.702-13.244c0.577-10.963,1.323-25.574,2.063-40.189c1.488-29.219,2.957-58.444,2.957-58.45
 c0.033-0.863,3.648-87.025,2.744-122.71c1.203-27.194,7.547-53.537,7.612-53.8l0.005-0.059c0.174-4.547,0.957-37.534,7.536-40.738
 l0.92,0.788c5.5,5.875,5.756,34.912,5.931,39.154c-0.005,0.07-0.005,0.114-0.011,0.12l0.011,0.005
 c0.011,0.224,0.022,0.454,0.027,0.679l0.011,0.059c0.066,0.263,6.39,26.562,7.593,53.733c-0.904,35.708,2.802,121.923,2.841,122.792
 c0,0,1.23,28.539,2.971,57.625c0.877,14.654,1.844,29.995,2.417,40.958c0.289,5.477-0.035,10.079,0.139,13.276
 c0.283,5.116,0.42,5.156,0.715,5.161c13.818,3.142,26.029,4.351,36.754,4.351c21.323,0,35.054-4.137,35.261-4.203l0.152-0.043
 l0.055-0.148c3.184-8.653,3.506-62.49,3.762-105.746c0.163-27.109,0.305-50.519,1.127-54.657
 C475.879,321.807,475.638,292.034,474.961,255.096z"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M355.769,370.389c0,0.027-0.006,0.12-0.012,0.269c-8.691,1.18-47.997,5.914-81.83,0.207
 c-0.147-22.348-0.349-40.355-1.076-43.985c-1.061-5.307-0.749-37.67-0.027-75.942c12.802,2.34,26.523,3.127,39.178,3.127
 c23.704,0,43.619-2.75,46.587-3.182C359.229,288.259,355.807,369.547,355.769,370.389"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M474.837,326.88c-0.722,3.619-0.93,21.522-1.077,43.766c-8.512,1.159-47.899,5.937-81.819,0.235
 c-0.016-0.284-0.022-0.453-0.028-0.492c-0.032-0.842-3.454-82.157-2.82-119.544c12.95,2.416,26.874,3.22,39.693,3.22
 c22.621,0,41.786-2.504,46.078-3.111C475.586,289.221,475.898,321.572,474.837,326.88"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M473.339,180.386l-31.537,0.344l-10.261,0.088h-0.016l0.027-3.576l41.623-4.04
 C473.23,175.575,473.284,177.969,473.339,180.386"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M340.227,41.194c-19.221,23.676-40.748,48.145-64.009,72.755c0.465-7.467,1.115-15.4,2.029-23.556
 c16.826-13.579,34.882-29.711,55.202-49.308C335.766,41.123,338.024,41.161,340.227,41.194"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M471.441,113.551c-23.298-24.649-44.864-49.162-64.112-72.876c2.28-0.038,4.537-0.071,6.767-0.103
 c20.359,19.635,38.442,35.794,55.295,49.39C470.31,98.124,470.971,106.067,471.441,113.551"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="378.012"
        y1="126.606"
        x2="378.012"
        y2="147.207"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="M474.14,365.153
 c0,0-0.216,0.039-0.633,0.107"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        x1="472.559"
        y1="365.413"
        x2="472.559"
        y2="365.413"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="
 M472.559,365.413c-8.098,1.273-45.87,6.55-80.438,0.22"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="
 M392.119,365.633c-0.211-0.038-0.421-0.077-0.632-0.117"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="
 M475.721,255.037c0,0-47.553,7.337-86.692,0"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="M356.22,365.153
 c0,0-0.217,0.039-0.633,0.107"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        x1="354.639"
        y1="365.413"
        x2="354.638"
        y2="365.413"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="
 M354.638,365.413c-8.097,1.273-45.869,6.55-80.438,0.22"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="
 M274.198,365.633c-0.21-0.038-0.421-0.077-0.631-0.117"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="
 M358.933,255.037c0,0-47.553,7.337-86.691,0"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="1.284,0.963"
        d="
 M275.784,476.172c0,0,33.092,9.761,74.949,0.272"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="1.284,0.963"
        d="
 M471.902,476.172c0,0-33.272,9.761-75.131,0.272"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M434.032,181.82
 c-0.001,0.209-0.003,0.418-0.003,0.627"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="434.022"
        y1="183.688"
        x2="434.022"
        y2="183.697"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.24"
        d="M434.022,183.696
 c-0.069,14.503,0.013,31.023,0.073,44.756c0.023,5.298,0.042,9.675,0.048,12.771"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M434.144,241.226
 c0.001,0.214,0.001,0.422,0.001,0.624l0.627-0.004"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="436.012"
        y1="241.84"
        x2="436.022"
        y2="241.839"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.25,1.239"
        x1="436.022"
        y1="241.839"
        x2="473.504"
        y2="241.634"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="473.504"
        y1="241.634"
        x2="474.132"
        y2="241.631"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M436.638,181.82
 c-0.001,0.21-0.003,0.419-0.004,0.628"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="436.628"
        y1="183.684"
        x2="436.628"
        y2="183.694"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.246,1.235"
        d="
 M436.628,183.693c-0.065,14.292,0.069,28.318,0.13,42.048c0.023,5.299,0.043,9.677,0.049,12.773"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        points="436.807,238.515 436.807,239.139 
 437.435,239.135 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="438.668"
        y1="239.127"
        x2="438.678"
        y2="239.127"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.244,1.233"
        x1="438.678"
        y1="239.127"
        x2="473.504"
        y2="238.916"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="473.504"
        y1="238.916"
        x2="474.132"
        y2="238.912"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="437.544"
        y1="224.978"
        x2="438.172"
        y2="224.978"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="439.449"
        y1="224.978"
        x2="439.459"
        y2="224.978"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.289,1.277,0.01,0"
        x1="439.459"
        y1="224.978"
        x2="472.951"
        y2="224.978"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="472.951"
        y1="224.978"
        x2="473.579"
        y2="224.978"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="437.544"
        y1="222.714"
        x2="438.172"
        y2="222.714"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="439.449"
        y1="222.714"
        x2="439.459"
        y2="222.714"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.289,1.277,0.01,0"
        x1="439.459"
        y1="222.714"
        x2="472.951"
        y2="222.714"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="472.951"
        y1="222.714"
        x2="473.579"
        y2="222.714"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="273.301"
        y1="242.497"
        x2="273.928"
        y2="242.512"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="275.155"
        y1="242.541"
        x2="275.165"
        y2="242.541"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.238,1.227"
        d="
 M275.165,242.541l31.295,0.739c1.032,0.025,1.889-0.792,1.913-1.824l1.121-47.444"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="309.494"
        y1="194.012"
        x2="309.509"
        y2="193.384"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="273.302"
        y1="239.777"
        x2="273.93"
        y2="239.793"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="275.191"
        y1="239.822"
        x2="275.201"
        y2="239.822"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.274,1.262,0.01,0"
        d="
 M275.201,239.822l28.711,0.679c1.031,0.024,1.888-0.792,1.912-1.825l1.057-44.727"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="306.881"
        y1="193.949"
        x2="306.897"
        y2="193.322"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="
 M373.843,126.623c0.149-0.046,0.302-0.094,0.459-0.144"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="375.213"
        y1="126.18"
        x2="375.214"
        y2="126.179"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="
 M375.214,126.179c3.353-1.137,7.815-3.033,10.502-5.72c1.782-1.782,2.668-4.181,3.007-6.641c0.344-2.489,0.05-4.943,0.087-7.432
 c0.027-1.821,0.008-3.644,0.013-5.466l0.021-8.698c0.009-3.374,0.016-6.747,0.024-10.121c0.009-3.552,0.018-7.105,0.027-10.657
 c0.007-3.436,0.016-6.872,0.024-10.308c0.008-3.024,0.015-6.049,0.023-9.072c0.005-2.318,0.01-4.634,0.016-6.951
 c0.003-1.315,0.007-2.629,0.01-3.944v-0.086"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M388.968,41.082
 c0-0.16,0.001-0.32,0.001-0.481"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="375.37"
        y1="41.04"
        x2="375.37"
        y2="41.521"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="375.369"
        y1="42.475"
        x2="375.369"
        y2="42.476"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        points="
 375.369,42.476 375.293,126.079 375.293,145.58 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="375.293"
        y1="145.579"
        x2="375.293"
        y2="146.06"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M290.398,16.098
 c0,0,75.555-15.519,166.742,0"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.963,0.963"
        d="
 M380.522,179.357c0.431-9.411,1.034-23.875,0.784-26.197c-0.375-3.489-5.101-5.717-7.305-5.06h-0.095
 c-2.203-0.657-6.93,1.571-7.305,5.06c-0.247,2.291,0.337,16.403,0.767,25.819"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.963,0.963"
        d="
 M368.653,169.509v-13.051c0-1.677,0.625-3.312,1.809-4.501c0.813-0.817,1.837-1.259,3.315-1.274"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.963,0.963"
        d="
 M379.215,169.624l-0.182-13.232c0-1.678-0.625-3.313-1.808-4.501c-0.815-0.818-1.837-1.259-3.316-1.275"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="
 M470.677,110.627c-21.791-23.184-42.256-46.368-61.396-69.552"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M276.932,111.08
 c21.791-23.184,42.257-46.368,61.396-69.552"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M297.449,19.43
 c0,0-1.124,26.007-1.217,26.233"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M300.689,19.43
 c0,0-1.124,26.007-1.217,26.233"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M450.13,19.43
 c0,0,1.125,26.007,1.217,26.233"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M446.891,19.43
 c0,0,1.124,26.007,1.217,26.233"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="431.2"
        y1="178.196"
        x2="473.352"
        y2="174.104"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="433.692"
        y1="152.482"
        x2="471.639"
        y2="151.802"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="433.883"
        y1="152.99"
        x2="434.146"
        y2="175.477"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.329"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
 433.057,151.543 434.189,153.316 433.971,151.557 435.102,153.33 434.885,151.57 436.015,153.343 435.799,151.584 436.928,153.356 
 436.712,151.598 437.84,153.369 437.626,151.611 438.752,153.383 438.538,151.625 439.664,153.397 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="303.538"
        y1="20.969"
        x2="371.957"
        y2="20.403"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M302.519,38.186
 c0,0,54.6,1.385,69.438,0.806"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="294.136"
        y1="37.847"
        x2="287.114"
        y2="37.516"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M294.97,20.969
 c0,0-3.438-0.34-6.271-2.266"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="375.37"
        y1="20.685"
        x2="443.547"
        y2="21.082"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="375.37"
        y1="39.043"
        x2="444.113"
        y2="37.733"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M452.609,21.082
 c0,0,3.419-0.633,6.57-2.039"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="453.066"
        y1="37.733"
        x2="460.425"
        y2="37.733"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="274.644"
        y1="189.274"
        x2="310.377"
        y2="190.119"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        points="
 310.543,166.076 310.212,180.068 274.778,179.23 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="274.845"
        y1="176.626"
        x2="310.274"
        y2="177.464"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        points="
 275.53,141.591 296.857,156.033 296.685,163.331 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="296.857"
        y1="156.033"
        x2="298.419"
        y2="157.09"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M200.9,360.309c-3.685,0.656-30.247,5.253-57.449,6.719c-2.816-13.219-5.505-26.273-5.964-29.832
 c-1.023-7.927-5.784-45.334-6.555-51.922c-0.798-6.827-5.433-30.4-5.877-32.657c0.05-0.132,0.072-0.372,0.028-0.848
 c25.802-2.52,53.087-7.435,55.973-7.965c3.739,30.761,6.537,48.915,9.243,60.128C193.618,317.68,197.302,338.043,200.9,360.309"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M84.27,238.272c-4.226,21.522-6.828,41.568-6.877,41.935c-0.006,0.262-0.503,26.497-4.756,56.486
 c-0.635,4.511-1.126,10.447-1.504,17.286c-3.088,0.186-22.424,1.246-44.542-0.252c-0.015-0.694-0.032-1.404-0.049-2.132
 c-0.092-4.493-0.174-9.32-0.251-14.765c-0.077-5.188-0.136-10.37-0.186-15.553c-0.055-5.122-0.099-10.244-0.131-15.366
 c-0.033-4.735-0.06-9.468-0.088-14.202c-0.016-4.03-0.032-8.053-0.044-12.077l-0.015-4.936c0-0.792-0.012-1.585-0.023-2.378
 c-0.032-2.372-0.065-4.827,0.159-7.233c0.437-4.722,1.591-9.505,2.711-14.13l0.154-0.623c1.126-4.674,2.454-9.474,4.061-14.673
 c0.279-0.918,0.568-1.837,0.863-2.761C56.866,237.506,80.333,238.19,84.27,238.272"
      />
      <polygon
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        points="204.956,176.247 196.477,177.149 169.855,179.91 169.751,179.904 145.545,183.037 136.962,184.113 
 136.612,181.314 203.683,166.062 204.316,171.426 "
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M222.87,92.373c-11.824,0.601-22.609,1.252-33.893,2.044l-6.615,0.448l-0.185-3.891l-0.29-4.303
 c5.39,0.284,10.966,0.612,16.367,0.93c7.922,0.464,16.11,0.94,24.015,1.311C222.482,90.077,222.684,91.23,222.87,92.373"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M167.193,111.173c-26.924-21.135-43.931-38.425-53.398-54.316c1.311-0.351,2.668-0.711,4.05-1.073
 c11.568,13.941,27.273,27.072,47.992,40.115C166.263,100.77,166.716,105.875,167.193,111.173"
      />
      <path
        d="M98.313,45.568c-1.159,0-2.028,1.891-2.028,4.4c0,2.51,0.869,4.402,2.028,4.402s2.033-1.892,2.033-4.402
 C100.346,47.459,99.472,45.568,98.313,45.568z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M206.957,41.571c-0.006,0.006-0.278,0.421-0.951,0.924l-0.246-0.535c0.727-1.006,0.705-1.723,0.7-1.799
 l-0.033-0.115c-0.038-0.082-3.761-8.102-6.096-21.997c-0.07-0.438-0.459-0.733-0.83-0.684h-0.815
 c-0.071-0.153-0.153-0.29-0.246-0.41l0.87-0.028l1.284,0.006c0.158,0,0.18,0.066,0.191,0.142
 c2.351,13.995,6.582,23.184,6.614,23.255C207.399,40.33,207.542,40.773,206.957,41.571"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M162.948,45.23
 c0.408,5.061,3.222,39.808,6.647,77.531l2.122,25.869"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M220.54,489.75c0,0-0.026-0.214-0.078-0.629"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="220.306"
        y1="487.859"
        x2="220.306"
        y2="487.858"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.273,1.272"
        d="
 M220.306,487.858c-2.064-16.565-17.316-137.439-28.561-184.001c-3.827-15.851-6.073-30.06-10.06-65.398"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M102.992,167.284
 c-0.007,0.181-0.019,0.391-0.035,0.633"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="102.842"
        y1="169.179"
        x2="102.842"
        y2="169.18"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.269,1.268"
        d="M102.842,169.18
 c-0.398,3.704-1.717,11.83-5.87,29.135c-10.649,24.354-18.352,84.277-18.352,84.277s-0.453,26.167-4.757,56.525
 c-3.848,27.138-2.373,105.127-2.016,121.365"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M71.847,460.481
 c0.005,0.224,0.01,0.435,0.014,0.634"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M104.126,171.654
 c-0.029,0.201-0.06,0.41-0.093,0.627"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="103.837"
        y1="173.536"
        x2="103.837"
        y2="173.537"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.272,1.271"
        d="
 M103.837,173.537c-0.766,4.717-2.287,12.421-5.279,24.891c-10.649,24.354-18.352,84.277-18.352,84.277s-0.453,26.167-4.757,56.525
 c-3.837,27.055-2.382,104.649-2.02,121.213"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M73.429,460.444
 c0.005,0.222,0.01,0.434,0.015,0.633"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M104.895,174.555
 c-0.035,0.203-0.071,0.411-0.108,0.624"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="104.563"
        y1="176.428"
        x2="104.563"
        y2="176.429"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.27,1.269"
        d="M104.563,176.429
 c-0.873,4.792-2.333,11.771-4.761,21.886c-10.647,24.354-18.35,84.277-18.35,84.277s-0.453,26.167-4.757,56.525
 c-3.84,27.076-2.38,104.769-2.02,121.251"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M74.676,460.369
 c0.005,0.222,0.01,0.434,0.014,0.633"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M164.153,477.916c0,0,0.215,0.043,0.622,0.117"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="166.044"
        y1="478.254"
        x2="166.044"
        y2="478.254"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.288,1.287"
        d="
 M166.044,478.254c6.902,1.153,31.365,4.545,51.101-1.449"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M217.145,476.804
 c0.203-0.062,0.404-0.124,0.605-0.187"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="224.367"
        y1="474.739"
        x2="224.368"
        y2="474.739"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.219,1.218"
        d="
 M219.896,476.141c3.825-1.166,17.245-5.364,20.596-6.984"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M240.493,469.156
 c0.211-0.103,0.399-0.199,0.562-0.291"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="M29.161,446.003
 c0,0,19.741,7.235,41.623,4.32"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="M75.449,449.788
 c0,0,20.76-1.309,29.41-4.393"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="104.546"
        y1="59.904"
        x2="104.56"
        y2="60.385"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        x1="104.586"
        y1="61.34"
        x2="104.586"
        y2="61.341"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        strokeDasharray="0.956,0.955"
        d="M104.586,61.341
 l1.561,56.548c0,0-0.322,12.428-8.31,14.716"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.321"
        strokeMiterlimit="10"
        d="M97.837,132.604
 c-0.152,0.044-0.308,0.084-0.466,0.12"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.426"
        strokeMiterlimit="10"
        strokeDasharray="1.279,1.279"
        d="
 M181.814,247.748c0,0-28.481,7.008-56.313,7.929"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="M83.944,241.473
 c0,0-25.593-0.349-51.341-5.605"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.445"
        strokeMiterlimit="10"
        strokeDasharray="1.335,1.335"
        d="
 M200.779,356.133c0,0-29.062,5.004-57.948,6.703"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.444"
        strokeMiterlimit="10"
        strokeDasharray="1.333,1.333"
        d="M71.824,350.305
 c0,0-21.335,1.375-45.686-0.277"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M165.826,67.978
 c10.052-0.92,38.033-2.972,50.663-1.139"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M165.6,66.279
 c9.735-0.895,37.314-3.143,50.247-1.453"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M172.827,21.175
 c0,0,3.479,25.793,3.435,26.031"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M175.725,20.668
 c0,0,3.479,25.793,3.435,26.03"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M141.11,28.651
 c0,0,3.479,25.793,3.435,26.03"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M144.008,28.145
 c0,0,3.479,25.793,3.435,26.03"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M139.018,185.353
 c0.026,0.207,0.053,0.414,0.078,0.622"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="139.25"
        y1="187.202"
        x2="139.252"
        y2="187.212"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.249,1.238"
        d="
 M139.252,187.212c1.657,13.157,3.672,28.074,5.339,40.458c0.641,4.77,1.173,8.711,1.542,11.506c0.043,0.33,0.357,0.566,0.693,0.522
 l31.946-4.091l29.22-3.563c1.035-0.126,1.762-1.026,1.636-2.027l-6.473-51.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="203.154"
        y1="178.559"
        x2="203.076"
        y2="177.936"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M141.208,185.099
 c0.026,0.208,0.052,0.415,0.077,0.623"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="141.441"
        y1="186.956"
        x2="141.442"
        y2="186.966"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.244,0.01,0"
        d="
 M141.442,186.966c1.632,12.942,3.396,25.604,5.059,37.982c0.62,4.612,1.135,8.449,1.503,11.224c0.064,0.485,0.525,0.832,1.02,0.769
 l29.435-3.783l27.685-3.367c0.693-0.085,1.178-0.686,1.094-1.357l-6.25-49.625"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="200.988"
        y1="178.809"
        x2="200.91"
        y2="178.187"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="136.94"
        y1="182.032"
        x2="204.149"
        y2="167.1"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="135.394"
        y1="159.288"
        x2="138.291"
        y2="179.781"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.329"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
 134.636,156.666 135.801,158.18 135.408,156.592 136.573,158.105 136.181,156.518 137.343,158.03 136.952,156.443 138.114,157.956 
 137.723,156.369 138.884,157.882 138.494,156.295 139.654,157.807 139.264,156.221 140.423,157.732 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="147.07"
        y1="224.179"
        x2="147.693"
        y2="224.105"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="148.93"
        y1="223.955"
        x2="148.941"
        y2="223.954"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.258,1.246,0.01,0"
        x1="148.94"
        y1="223.954"
        x2="203.855"
        y2="217.352"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="203.855"
        y1="217.353"
        x2="204.478"
        y2="217.278"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="146.803"
        y1="222.129"
        x2="147.426"
        y2="222.054"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="148.664"
        y1="221.905"
        x2="148.674"
        y2="221.904"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.258,1.247,0.01,0"
        x1="148.674"
        y1="221.904"
        x2="203.599"
        y2="215.313"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="203.599"
        y1="215.314"
        x2="204.222"
        y2="215.24"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="
 M199.572,150.537c-6.437,0.6-12.883,1.202-19.338,1.802c-10.007,0.928-20.061,2.154-30.097,3.478
 c-1.342,0.177-2.685,0.354-4.029,0.532c-3.624,0.478-7.25,0.958-10.88,1.437"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="199.844"
        y1="150.298"
        x2="201.332"
        y2="164.405"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="201.917"
        y1="168.293"
        x2="202.777"
        y2="175.892"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.329"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
 200.343,149.377 199.794,151.071 199.774,149.453 198.849,151.19 198.827,149.572 198.091,151.288 198.07,149.67 197.334,151.385 
 197.312,149.768 196.577,151.482 196.554,149.865 195.821,151.58 195.797,149.963 195.064,151.678 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M221.792,138.286
 c-0.21,0.008-0.419,0.016-0.628,0.024"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="219.903"
        y1="138.362"
        x2="219.892"
        y2="138.362"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.274,1.262,0.01,0"
        d="
 M219.893,138.362c-10.812,0.456-21.615,1.224-32.418,1.563c-0.238,0-0.357-0.119-0.596-0.239c-0.476-0.36-0.476-0.72-0.595-1.199
 c-0.94-14.062-1.532-27.891-2.266-41.841"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M184.018,96.647
 c-0.01-0.209-0.021-0.418-0.032-0.627"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M221.771,136.285
 c-0.209,0.006-0.417,0.011-0.626,0.017"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="219.898"
        y1="136.341"
        x2="219.889"
        y2="136.341"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.259,1.248,0.01,0"
        d="
 M219.89,136.341c-10.442,0.347-20.893,1.313-31.343,1.427c-0.595,0-0.595-0.72-0.715-1.32c-0.821-13.341-1.412-26.567-2.101-39.896"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M185.73,96.549
 c-0.012-0.21-0.022-0.419-0.033-0.628"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M222.124,89.501
 c-13.345-0.63-27.146-1.385-40.497-1.997"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M223.492,125.784
 c-0.208,0.011-0.416,0.022-0.625,0.033"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        x1="221.625"
        y1="125.884"
        x2="221.617"
        y2="125.884"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.254,1.243"
        d="
 M221.617,125.884c-10.437,0.552-22.246,1.106-32.541,1.753"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M189.074,127.637
 c-0.209,0.013-0.418,0.026-0.625,0.039"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M223.482,124.105
 c-0.208,0.014-0.416,0.027-0.625,0.04"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="221.613"
        y1="124.223"
        x2="221.605"
        y2="124.223"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.257,1.246,0.01,0"
        d="
 M221.605,124.223c-10.521,0.639-22.244,1.094-32.617,1.748"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        d="M188.985,125.971
 c-0.209,0.013-0.417,0.026-0.625,0.039"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="182.251"
        y1="69.451"
        x2="183.427"
        y2="84.958"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="183.523"
        y1="88.148"
        x2="183.928"
        y2="94.343"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="
 M166.619,109.098c-24.183-18.922-40.797-34.47-51.46-52.682"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="95.616"
        y1="43.171"
        x2="138.979"
        y2="30.824"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="95.616"
        y1="59.667"
        x2="140.792"
        y2="47.589"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="146.796"
        y1="28.898"
        x2="170.584"
        y2="23.419"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M148.858,45.705
 c0,0,13.683-3.44,24.331-4.8"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        x1="178.399"
        y1="21.875"
        x2="196.977"
        y2="18.363"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.254"
        d="M181.118,39.546
 c0,0,8.496-1.359,19.937-3.285"
      />
      <path
        d="M242.737,482.849c-0.449-9.08-7.408-64.151-7.473-64.697c-0.05-0.438-4.57-43.832-7.479-62.205
 c-1.957-12.338-5.963-28.181-8.178-36.529c-1.47-5.559-2.181-11.298-2.099-17.061c0.142-10.359,0.257-23.517-0.027-27.377
 c-0.131-1.766-0.471-4.236-0.865-7.095c-0.972-7.101-2.306-16.827-1.743-25.032c0.246-3.581,0.859-8.681,1.569-14.579
 c1.569-13.038,3.722-30.887,3.64-47.063c-0.087-18.772,0.897-31.422,1.324-35.992c0.082-0.858,0.24-1.711,0.464-2.537
 c2.149-7.86,11.54-49.538-14.727-97.765l-0.859-1.826c0.865-0.617,1.204-1.153,1.204-1.158c0.797-1.083,0.541-1.771,0.502-1.854
 c-0.043-0.092-4.231-9.206-6.571-23.107c-0.07-0.421-0.387-0.684-0.825-0.684h-1.295l-1.782,0.055
 c-0.4-0.098-0.897-0.093-1.521,0.027c-25.321,4.756-48.412,10.103-70.595,16.351c-2.996,0.842-5.97,1.656-8.933,2.471
 c-7.172,1.969-14.59,4.002-21.937,6.352c-0.356,0.137-0.596,0.487-0.596,0.869v19.828l0.006-0.005
 c0.082,3.034,0.606,22.407,1.088,37.96l0.004,0.191l-0.835,1.427c-0.832,1.437-1.657,2.881-2.483,4.324
 c-1.29,2.269-2.569,4.537-3.837,6.817c-1.635,2.941-3.303,5.975-4.953,9.009c-1.963,3.618-3.925,7.281-5.827,10.884
 c-2.182,4.139-4.352,8.325-6.451,12.447c-2.34,4.592-4.641,9.2-6.844,13.705c-2.416,4.948-4.768,9.878-6.986,14.651
 c-2.411,5.182-4.729,10.326-6.889,15.285c-2.323,5.318-4.526,10.572-6.549,15.601c-2.191,5.457-4.143,10.562-5.964,15.613
 c-1.94,5.38-3.624,10.392-5.143,15.323c-1.608,5.21-2.937,10.021-4.073,14.705l-0.148,0.623c-1.126,4.652-2.291,9.458-2.727,14.225
 c-0.23,2.443-0.192,4.909-0.16,7.303c0.012,0.788,0.023,1.58,0.023,2.373l0.011,4.93c0.016,4.03,0.027,8.053,0.048,12.076
 c0.023,4.74,0.05,9.474,0.082,14.208c0.038,5.122,0.082,10.245,0.132,15.367c0.055,5.182,0.114,10.37,0.186,15.552
 c0.082,5.451,0.164,10.278,0.257,14.771c0.103,4.98,0.208,9.113,0.328,13.016c0.098,3.039,0.223,6.636,0.421,10.289l0.01,0.218
 c0.116,2.099,0.23,4.264,0.509,6.385c0.044,0.35,0.093,0.699,0.158,1.05c1.957,10.091,1.963,31.017,1.017,39.666
 c-0.897,8.199,1.225,34.008,1.247,34.269l0.016,0.175l0.159,0.082c0.103,0.055,10.151,5.035,26.032,5.035
 c0.503,0,1.017-0.005,1.53-0.016c15.837-0.317,26.42-0.76,36.965-2.165c10.021-1.339,10.759-3.717,10.808-3.985l0.006-0.06
 c0-0.366,0.126-36.872,1.246-52.54c0.65-9.08,1.214-18.882,1.733-29.951c0.366-7.965,0.743-16.46,0.863-25.021
 c0.05-3.619,0-7.266-0.044-10.786c-0.097-7.647-0.202-15.547,0.717-23.402c1.777-15.111,4.866-30.264,7.856-44.914
 c0.36-1.76,0.721-3.527,1.077-5.287c0.885-4.356,2.285-8.992,5.914-10.687c0.651,3.302,5.046,25.754,5.822,32.374
 c0.777,6.587,5.538,44,6.555,51.927c1.011,7.85,12.819,61.516,12.939,62.062c0.093,0.4,9.638,40.044,11.092,56.821
 c1.476,16.996,4.986,32.488,5.625,33.253c0.459,0.552,8.911,3.1,21.927,3.526c1.181,0.039,2.422,0.06,3.733,0.06
 c12.163,0,29.837-1.891,50.37-9.834l0.213-0.088L242.737,482.849z M221.919,139.828c-1.393,0.061-2.82,0.11-4.258,0.16
 c-1.645,0.059-3.324,0.12-4.969,0.196l-0.12,0.006c-0.821,0.038-1.635,0.076-2.433,0.126l0.006,0.015l-24.278,1.406
 c-0.169,0.01-0.328-0.044-0.454-0.154c-0.12-0.109-0.196-0.261-0.202-0.431c-0.126-2.29-0.322-5.68-0.552-9.709
 c-0.607-10.523-1.438-24.928-1.973-35.954l6.336-0.426c11.304-0.793,22.106-1.443,33.953-2.045
 C226.441,115.245,223.619,132.406,221.919,139.828 M222.87,92.373c-11.824,0.601-22.609,1.252-33.892,2.044l-6.615,0.449
 l-0.186-3.892l-0.29-4.303c5.391,0.284,10.967,0.613,16.367,0.93c7.922,0.465,16.111,0.94,24.016,1.311
 C222.483,90.078,222.685,91.231,222.87,92.373 M222.144,88.257c-7.856-0.372-15.985-0.843-23.852-1.306
 c-5.427-0.318-11.037-0.646-16.454-0.93l-1.181-17.362c12.016-0.809,27.563-1.432,36.239-0.071
 C219.252,75.432,220.947,82.019,222.144,88.257 M206.57,45.207c4.236,7.774,7.532,15.377,10.09,22.692
 c-14.913-2.203-48.773,1.11-52.452,1.481c-1.147-13.661-1.853-22.598-1.984-24.288c1.465-0.267,2.93-0.53,4.395-0.793
 c1.623-0.289,3.247-0.573,4.871-0.857c0.388-0.072,1-0.17,1.607-0.269c0.421-0.071,0.831-0.136,1.164-0.191l0.612,4.805
 c0.039,0.295,0.187,0.558,0.4,0.716c0.136,0.099,0.284,0.148,0.437,0.148c0.038,0,0.076,0,0.114-0.005l4.407-0.772
 c0.416-0.076,0.683-0.507,0.623-1.016l-0.59-4.909c0.114-0.022,0.24-0.049,0.366-0.071c0.29-0.06,0.579-0.121,0.672-0.136
 c1.569-0.269,3.133-0.537,4.702-0.799c1.465-0.251,2.93-0.497,4.395-0.743c1.323-0.219,2.651-0.438,3.974-0.662
 c1.143-0.186,2.285-0.372,3.428-0.563c0.918-0.147,1.837-0.295,2.755-0.442l0.481-0.078c0.519-0.086,1.038-0.168,1.558-0.246
 c0.219-0.032,0.437-0.059,0.661-0.087L206.57,45.207z M118.534,55.599c7.698-2.033,16.204-4.242,23.884-6.134l0.739,5.801
 c0.038,0.295,0.185,0.558,0.398,0.716c0.132,0.098,0.285,0.147,0.437,0.147c0.039,0,0.078-0.006,0.116-0.01l4.406-0.771
 c0.415-0.071,0.683-0.509,0.623-1.012l-0.749-6.27c5.193-1.225,10.069-2.279,13.196-2.859c0.225,2.831,1.777,22.452,4.182,49.888
 C145.425,82.244,129.96,69.315,118.534,55.599 M165.837,95.899c0.427,4.871,0.88,9.976,1.357,15.274
 c-26.924-21.135-43.931-38.425-53.399-54.316c1.312-0.351,2.668-0.711,4.051-1.072C129.413,69.725,145.118,82.856,165.837,95.899
  M203.721,37.357c-1.399-3.537-2.487-7.528-3.433-12.563l-0.339-1.667c-0.295-1.448-0.58-2.902-0.853-4.356
 c-0.055-0.279-0.114-0.53-0.175-0.766h0.623c0.077-0.01,0.137,0.055,0.154,0.148c2.236,13.311,5.745,21.276,6.117,22.095
 c-0.006,0.132-0.066,0.509-0.377,1.034l-1.662-3.559C203.792,37.624,203.782,37.504,203.721,37.357 M199.31,16.928l1.284,0.006
 c0.158,0,0.181,0.065,0.191,0.142c2.351,13.995,6.582,23.184,6.615,23.254c0,0,0.142,0.444-0.443,1.242
 c-0.006,0.006-0.278,0.421-0.951,0.923l-0.246-0.535c0.728-1.006,0.705-1.722,0.7-1.798l-0.033-0.116
 c-0.038-0.082-3.761-8.101-6.096-21.997c-0.07-0.437-0.459-0.732-0.83-0.683h-0.814c-0.071-0.154-0.154-0.29-0.246-0.411
 L199.31,16.928z M196.112,17.004c0.852-0.163,1.378-0.103,1.694,0.181c0.339,0.307,0.509,0.902,0.656,1.7
 c0.274,1.46,0.558,2.919,0.859,4.373l0.338,1.662c0.935,5.002,2.023,8.988,3.428,12.579c-0.197,0.022-0.393,0.049-0.585,0.077
 c-0.525,0.076-1.044,0.158-1.569,0.246l-0.481,0.076c-0.919,0.147-1.836,0.296-2.755,0.443c-1.143,0.192-2.286,0.377-3.428,0.569
 c-1.328,0.218-2.651,0.437-3.974,0.661c-1.465,0.241-2.935,0.492-4.4,0.738c-1.57,0.263-3.133,0.53-4.702,0.798
 c-0.093,0.016-0.394,0.077-0.694,0.137c-0.104,0.022-0.214,0.043-0.312,0.065l-2.471-20.663
 C183.724,19.388,189.852,18.18,196.112,17.004 M177.087,20.777l3.127,26.158c0.023,0.185-0.054,0.3-0.093,0.306l-4.406,0.77
 c-0.021,0-0.049-0.016-0.059-0.021c-0.055-0.044-0.126-0.143-0.143-0.285l-3.307-25.889
 C173.824,21.465,175.453,21.121,177.087,20.777 M171.577,21.952l2.602,20.39c-0.339,0.055-0.76,0.126-1.186,0.197
 c-0.607,0.099-1.224,0.197-1.618,0.268c-1.624,0.284-3.247,0.568-4.871,0.858c-1.563,0.28-3.121,0.564-4.684,0.842
 c-3.106,0.569-8.135,1.652-13.508,2.914l-2.335-19.505C154.314,25.823,162.825,23.843,171.577,21.952 M145.349,28.075l3.148,26.337
 c0.022,0.187-0.054,0.296-0.092,0.301l-4.407,0.772c-0.022,0.005-0.049-0.012-0.06-0.023c-0.055-0.038-0.125-0.136-0.142-0.278
 l-3.302-25.874C142.107,28.895,143.725,28.485,145.349,28.075 M94.574,42.413c0-0.12,0.077-0.229,0.169-0.262
 c7.315-2.339,14.728-4.373,21.895-6.341c2.963-0.809,5.936-1.629,8.937-2.471c4.718-1.329,9.48-2.613,14.29-3.865l2.471,19.352
 c-9.381,2.312-20.008,5.089-28.886,7.461c-0.004-0.01-0.016-0.021-0.021-0.032l-0.115,0.066c-9.485,2.531-16.952,4.581-18.74,5.073
 V42.413z M38.017,220.369c1.82-5.046,3.766-10.146,5.958-15.591c2.017-5.024,4.221-10.272,6.538-15.591
 c2.16-4.947,4.478-10.086,6.883-15.263c2.22-4.772,4.564-9.697,6.981-14.639c2.202-4.505,4.504-9.114,6.838-13.694
 c2.1-4.122,4.27-8.309,6.451-12.442c1.903-3.603,3.86-7.26,5.823-10.879c1.65-3.034,3.312-6.063,4.952-9.003
 c1.268-2.274,2.548-4.549,3.832-6.812c0.826-1.443,1.651-2.88,2.482-4.319c0.104-0.18,0.213-0.36,0.317-0.541
 c0.268,8.594,0.525,15.793,0.672,18.013c0.459,6.751,3.089,28.711,6.008,44.329l0.066-0.011l-0.066,0.016
 c0.032,0.159,0.634,4.264-5.991,31.892c-4.39,10.054-8.299,26.262-11.365,41.798c-3.548-0.071-27.169-0.721-50.447-5.351
 C35.185,228.443,36.525,224.518,38.017,220.369 M26.542,351.595c-0.093-4.493-0.175-9.32-0.252-14.766
 c-0.076-5.187-0.135-10.37-0.185-15.552c-0.055-5.122-0.099-10.244-0.131-15.366c-0.033-4.735-0.061-9.468-0.088-14.203
 c-0.017-4.029-0.032-8.052-0.044-12.076l-0.016-4.936c0-0.792-0.011-1.585-0.022-2.378c-0.032-2.372-0.065-4.827,0.159-7.233
 c0.437-4.722,1.591-9.506,2.711-14.131l0.153-0.623c1.126-4.673,2.455-9.473,4.062-14.672c0.279-0.918,0.568-1.837,0.863-2.761
 c23.114,4.608,46.582,5.292,50.518,5.374c-4.226,21.522-6.828,41.568-6.877,41.934c-0.006,0.263-0.503,26.497-4.756,56.487
 c-0.635,4.51-1.126,10.447-1.504,17.286c-3.088,0.185-22.424,1.246-44.542-0.252C26.575,353.033,26.559,352.323,26.542,351.595
  M57.32,461.135c-15.482,0.312-25.715-4.22-27.104-4.876c-0.186-2.334-2.083-26.18-1.23-33.964c0.852-7.779,1.11-28.82-1.023-39.851
 c-0.065-0.34-0.114-0.679-0.158-1.012c-0.273-2.1-0.388-4.253-0.503-6.336l-0.011-0.224c-0.197-3.641-0.322-7.238-0.416-10.272
 c-0.097-3.148-0.185-6.456-0.272-10.228c8.839,0.596,17.23,0.788,24.326,0.788c10.518,0,18.171-0.416,20.172-0.537
 c-1.995,37.469-0.541,101.073-0.421,106.157C66.629,460.928,62.229,461.037,57.32,461.135 M124.498,252.25
 c-4.116,1.701-5.63,6.653-6.57,11.284c-0.355,1.765-0.717,3.525-1.077,5.291c-2.99,14.662-6.084,29.826-7.861,44.968
 c-0.929,7.894-0.826,15.816-0.727,23.48c0.049,3.52,0.099,7.161,0.044,10.768c-0.12,8.55-0.492,17.04-0.864,25.005
 c-0.514,11.065-1.082,20.856-1.728,29.936c-1.103,15.415-1.24,50.954-1.246,52.528c-0.104,0.235-1.252,2.258-10.261,3.461
 c-7.079,0.945-14.175,1.454-22.884,1.781c-0.147-6.1-2.175-94.873,1.953-123.966c4.258-30.034,4.755-56.306,4.755-56.531
 c0.077-0.6,7.818-60.154,18.33-84.191l0.016-0.055c4.412-18.384,5.637-26.431,5.943-29.842l2.634,10.316
 c0.328,1.284,1.41,5.275,2.914,10.802C112.931,205.926,124.701,249.287,124.498,252.25 M119.322,227.552
 c-3.559-13.629-7.938-29.761-10.835-40.436c-1.497-5.522-2.58-9.513-2.909-10.791l-3.197-12.514
 c-2.914-15.597-5.538-37.507-5.997-44.247c-0.159-2.328-0.427-10.173-0.711-19.358L94.58,62.061
 c1.415-0.394,8.916-2.455,18.565-5.029c9.555,16.093,26.775,33.597,54.13,55.021c0.382,4.259,0.782,8.632,1.192,13.109l1.771,24.523
 l-3.641,0.366l-33.21,4.139c-0.306,0.038-0.579,0.196-0.765,0.437c-0.18,0.241-0.262,0.535-0.218,0.836l3.312,23.857l0.678,5.51
 l0.487-0.06c1.699,13.612,4.094,31.4,5.844,44.39c0.628,4.657,1.164,8.626,1.536,11.435c0.137,1.017,1.017,1.755,2.033,1.755
 c0.093,0,0.186-0.006,0.274-0.017l32.006-4.116l1.783-0.208c0.208,1.761,0.415,3.472,0.623,5.155
 c-2.668,0.487-30.072,5.44-55.979,7.971C124.652,248.741,123.29,242.765,119.322,227.552 M176.885,237.786l-29.284,3.766
 l-1.115,0.148c-0.76,0.103-1.493-0.449-1.591-1.192c-0.372-2.805-0.903-6.773-1.53-11.436c-1.75-12.99-4.145-30.778-5.85-44.378
 l8.112-1.012l24.147-3.127l0.097,0.006l26.678-2.767l8.118-0.863c1.766,13.486,3.914,31.165,5.483,44.072
 c0.595,4.936,1.104,9.091,1.454,11.901c0.027,0.218-0.032,0.431-0.169,0.606c-0.148,0.187-0.361,0.301-0.608,0.328l-30.722,3.554
 l-0.005-0.022l-1.618,0.208l-1.602,0.185L176.885,237.786z M196.478,177.15l-26.622,2.761l-0.105-0.006l-24.206,3.132l-8.583,1.077
 l-0.349-2.799l67.07-15.252l0.634,5.363l0.639,4.821L196.478,177.15z M136.536,180.664l-0.18-1.426l-3.313-23.868
 c-0.016-0.125,0.017-0.246,0.093-0.349c0.082-0.105,0.202-0.17,0.333-0.187l32.894-4.105l34.586-3.471h0.055
 c0.263,0,0.492,0.186,0.525,0.443l2.083,17.711L136.536,180.664z M137.488,337.196c-1.023-7.927-5.785-45.334-6.555-51.922
 c-0.798-6.827-5.434-30.4-5.877-32.657c0.05-0.132,0.071-0.372,0.027-0.848c25.803-2.52,53.087-7.435,55.974-7.965
 c3.738,30.761,6.537,48.915,9.243,60.128c3.318,13.748,7.003,34.111,10.601,56.377c-3.685,0.656-30.247,5.253-57.45,6.719
 C140.636,353.809,137.947,340.755,137.488,337.196 M188.885,492.312c-13.804-0.4-21.533-3.067-21.883-3.302
 c-0.519-0.776-4.012-15.925-5.483-32.904c-1.46-16.82-11.01-56.514-11.109-56.907c-0.065-0.29-3.503-15.925-6.828-31.532
 c27.181-1.476,53.689-6.062,57.422-6.724c8.998,55.847,17.406,123.349,18.045,128.537
 C206.799,492.049,196.445,492.531,188.885,492.312 M219.678,489.349c-0.968-7.828-17.11-137.344-28.754-185.565
 c-2.865-11.873-5.839-31.57-9.928-65.845l29.903-3.461c0.416-0.049,0.787-0.251,1.039-0.568c0.246-0.312,0.349-0.695,0.301-1.082
 c-0.351-2.816-0.854-6.971-1.455-11.907c-1.569-12.901-3.717-30.569-5.483-44.061l0.383-0.044l-0.728-5.467l-2.788-23.725
 c-0.07-0.623-0.65-1.077-1.284-1.011l-30.007,3.007l-1.77-24.513c-1.98-21.5-3.647-40.797-4.844-55.087
 c1.443-0.148,7.752-0.766,15.749-1.317l1.52,22.309l0.213,4.537l0.301-0.016c0.535,11.026,1.361,25.425,1.968,35.949
 c0.235,4.023,0.427,7.412,0.552,9.708c0.022,0.339,0.17,0.65,0.421,0.875c0.235,0.208,0.53,0.317,0.841,0.317h0.078l26.704-1.553
 c1.678-0.077,3.394-0.136,5.073-0.197c1.378-0.049,2.744-0.097,4.084-0.158c-0.197,0.825-0.372,1.515-0.52,2.039
 c-0.235,0.863-0.393,1.749-0.481,2.646c-0.426,4.576-1.416,17.258-1.323,36.052c0.077,16.138-2.072,33.964-3.635,46.986
 c-0.716,5.91-1.328,11.015-1.574,14.612c-0.569,8.271,0.77,18.034,1.749,25.163c0.388,2.849,0.727,5.309,0.852,7.052
 c0.301,4.046,0.148,18.854,0.033,27.328c-0.082,5.816,0.629,11.616,2.122,17.236c2.208,8.331,6.209,24.146,8.161,36.457
 c2.909,18.357,7.423,61.735,7.473,62.177c0.071,0.553,6.915,54.705,7.462,64.425C234.126,485.713,226.61,487.862,219.678,489.349"
      />
      <path
        d="M475.509,250.861c0.147-0.022,0.241-0.033,0.263-0.038l-0.099-0.634c-0.017,0-0.076,0.011-0.175,0.027
 c-0.399-20.942-0.924-43.88-1.427-65.796c-0.399-17.51-0.776-34.052-1.049-47.86c-0.481-24.431-2.81-60.341-11.185-92.687
 c-0.235-0.913-0.426-1.64-0.448-1.826v-0.011c1.651-11.54-0.836-24.719-1.526-26.923v-0.054h-0.015
 c-0.055-0.159-0.094-0.246-0.121-0.269l-0.159-0.109l-0.044,0.022C413.238,5.53,369.096,6.017,340.21,8.045
 c-30.192,2.121-50.451,6.314-52.059,6.652l-0.038-0.016l-0.049,0.039h-0.022v0.011l-0.088,0.059
 c-0.021,0.023-0.065,0.11-0.114,0.269l-0.017,0.054c-0.688,2.204-3.175,15.383-1.53,26.923l0.005,0.011
 c-0.027,0.186-0.213,0.913-0.448,1.826c-8.375,32.352-10.709,68.262-11.19,92.687c-0.268,13.814-0.651,30.356-1.05,47.865
 c-1.438,62.91-3.067,134.217-1.388,142.581c0.825,4.139,0.968,27.552,1.126,54.666c0.262,43.263,0.585,97.109,3.783,105.763
 l0.055,0.148l0.152,0.043c0.307,0.099,31.297,9.403,72.745,0.017c0.295-0.005,0.306-0.208,0.585-5.325
 c0.175-3.198,0.421-7.768,0.705-13.246c0.579-10.965,1.328-25.578,2.071-40.196c1.494-29.224,2.969-58.454,2.969-58.46
 c0.033-0.863,3.663-87.039,2.755-122.73c1.208-27.198,7.577-53.546,7.643-53.809l0.005-0.059c0.613-15.98,2.985-39.814,7.025-40.093
 c3.974,0.273,6.336,23.332,6.997,39.289c-0.005,0.07-0.005,0.114-0.011,0.12l0.011,0.005c0.011,0.224,0.022,0.454,0.027,0.679
 l0.011,0.059c0.066,0.263,6.435,26.611,7.643,53.786c-0.908,35.714,2.716,121.89,2.755,122.759c0,0,1.47,29.23,2.962,58.454
 c0.749,14.618,1.498,29.231,2.073,40.196c0.29,5.478,0.53,10.048,0.705,13.246c0.284,5.117,0.295,5.32,0.591,5.325
 c13.874,3.143,26.573,4.187,37.341,4.187c21.409,0,35.195-4.138,35.403-4.204l0.153-0.043l0.055-0.148
 c3.197-8.654,3.52-62.5,3.777-105.763c0.164-27.114,0.306-50.527,1.132-54.666C476.548,321.583,476.247,289.729,475.509,250.861
  M473.432,184.431c0.437,19.166,0.907,39.83,1.296,59.34l-42.17,0.257h-0.585c0-3.105-0.022-8.128-0.049-14.213
 c-0.061-14.159-0.148-33.483-0.066-48.353l9.955-0.082l31.543-0.344C473.377,182.162,473.404,183.294,473.432,184.431
  M473.339,180.386l-31.537,0.344l-10.261,0.088h-0.017l0.028-3.576l41.623-4.04C473.23,175.575,473.284,177.969,473.339,180.386
  M473.158,172.552l-41.6,4.04l0.01-1.149l-0.235-26.714l41.29-0.449C472.787,155.879,472.967,164.04,473.158,172.552
  M471.441,113.551c-23.297-24.65-44.864-49.162-64.112-72.876c2.28-0.038,4.537-0.071,6.768-0.104
 c20.358,19.636,38.441,35.795,55.295,49.391C470.311,98.124,470.972,106.067,471.441,113.551 M445.935,39.45
 c-14,0.202-48.692,0.711-71.772,1.143V19.055l70.585,0.503L445.935,39.45z M445.388,19.558l4.385,0.032c0.07,0,0.507,0,1.164-0.049
 l1.35,26.485c0.005,0.11-0.027,0.219-0.088,0.285c-0.027,0.022-0.059,0.049-0.103,0.049h-4.926c-0.087,0-0.186-0.115-0.196-0.284
 L445.388,19.558z M469.288,89.049c-16.563-13.393-34.33-29.269-54.278-48.494c12.721-0.197,24.239-0.366,30.963-0.459l0.361,6.018
 c0.027,0.497,0.394,0.891,0.836,0.891h4.926c0.207,0,0.41-0.093,0.568-0.257c0.181-0.191,0.278-0.465,0.268-0.754l-0.312-6.018
 c4.046-0.055,7.331-0.082,8.381-0.094c-0.066,0.667-0.143,1.329-0.235,1.984c-0.072,0.154,0.016,0.488,0.448,2.165
 C465.029,58.77,467.588,74.251,469.288,89.049 M461.061,39.242c-0.973,0.006-4.325,0.034-8.473,0.094l-1.012-19.855
 c2.22-0.247,5.909-1.044,7.839-3.646C460.05,18.628,461.946,29.162,461.061,39.242 M288.267,15.84
 c1.962,2.679,5.635,3.554,7.723,3.838l-1.006,19.767c-3.99-0.126-7.384-0.186-8.358-0.203
 C285.74,29.173,287.632,18.634,288.267,15.84 M296.63,19.754c0.514,0.055,0.848,0.061,0.907,0.065l4.642-0.048l-1.574,26.305
 c-0.011,0.169-0.11,0.284-0.192,0.284h-4.926c-0.044,0-0.082-0.027-0.103-0.049c-0.066-0.066-0.099-0.175-0.093-0.285L296.63,19.754
 z M286.468,44.037c0.437-1.683,0.524-2.017,0.453-2.171c-0.093-0.655-0.175-1.317-0.24-1.978c1.06,0.016,4.379,0.076,8.271,0.196
 l-0.301,5.91c-0.016,0.289,0.082,0.563,0.268,0.76c0.153,0.158,0.356,0.251,0.568,0.251h4.926c0.438,0,0.804-0.394,0.831-0.891
 l0.35-5.784c11.157,0.318,21.512,0.564,30.941,0.738c-19.91,19.188-37.649,35.037-54.185,48.413
 C280.05,74.557,282.619,58.917,286.468,44.037 M278.246,90.394c16.826-13.579,34.883-29.711,55.202-49.309
 c2.318,0.038,4.576,0.076,6.779,0.109c-19.221,23.676-40.748,48.145-64.009,72.755C276.683,106.483,277.333,98.55,278.246,90.394
  M275.305,136.576c0.006-0.481,0.021-0.967,0.033-1.454l21.942,15.438c1.203,0.847,1.903,2.23,1.865,3.701l-0.241,10.32
 l-24.184-0.573C274.939,154.135,275.141,144.863,275.305,136.576 M274.703,164.652l37.568,0.886l-0.4,16.816l-37.551-0.886
 C274.452,175.723,274.583,170.098,274.703,164.652 M274.255,184.442c0.017-0.782,0.033-1.558,0.05-2.334l37.555,0.89
 c-0.049,2.548-0.104,5.369-0.169,8.364l-37.573-0.885C274.162,188.448,274.206,186.437,274.255,184.442 M274.103,191.116
 l37.571,0.892c-0.432,19.636-1.196,46.312-1.366,52.212c-0.011,0.409-0.186,0.798-0.487,1.082c-0.3,0.284-0.711,0.427-1.11,0.421
 l-35.768-1.067C273.287,227.136,273.703,208.643,274.103,191.116 M349.749,487.058c-39.677,8.938-69.672,0.7-72.071,0
 c-3.106-9.003-3.428-62.423-3.685-105.391c-0.022-3.455-0.044-6.849-0.066-10.151c12.196,2.05,25.087,2.749,37.01,2.749
 c21.062,0,39.081-2.181,44.788-2.952C355.184,382.023,350.149,481.816,349.749,487.058 M355.769,370.389
 c0,0.027-0.006,0.12-0.012,0.268c-8.691,1.181-47.997,5.914-81.83,0.207c-0.148-22.347-0.35-40.354-1.076-43.984
 c-1.061-5.308-0.749-37.67-0.028-75.942c12.803,2.339,26.524,3.127,39.179,3.127c23.703,0,43.618-2.75,46.587-3.182
 C359.229,288.259,355.807,369.547,355.769,370.389 M373.524,153.129c-4.477,1.187-6.358,23.146-7.036,34.445
 c-0.492-10.441-1.464-32.215-1.131-35.32c0.24-2.235,2.011-3.723,3.044-4.406c1.722-1.148,3.8-1.695,5.123-1.366V153.129z
  M373.524,145.825c-1.503-0.3-3.652,0.269-5.478,1.488c-1.946,1.296-3.127,3.022-3.329,4.876
 c-0.443,4.132,1.323,39.474,1.399,40.977h0.082c-0.005,0.235-0.016,0.438-0.021,0.591c-0.257,1.066-6.462,27.065-7.653,53.923
 c0.021,0.825,0.038,1.678,0.054,2.553c-4.067,0.595-48.806,6.838-85.744,0.054c0.032-1.65,0.066-3.312,0.093-4.985l35.768,1.06
 h0.066c0.562,0,1.093-0.208,1.503-0.595c0.427-0.4,0.667-0.947,0.683-1.532c0.203-6.904,1.214-42.322,1.558-61.542l0.416-17.46
 c0-0.082-0.033-0.165-0.093-0.231c-0.054-0.059-0.137-0.093-0.224-0.098l-13.06-0.306l0.246-10.326
 c0.038-1.684-0.76-3.27-2.138-4.237l-22.298-15.689c0.136-5.915,0.393-12.447,0.803-19.396
 c23.606-24.944,45.434-49.757,64.89-73.745c7.117,0.099,13.611,0.148,19.417,0.148c4.844,0,9.206-0.033,13.06-0.104V145.825z
  M373.524,40.604c-15.99,0.296-40.831-0.022-71.892-0.913l1.186-19.926l70.416-0.699l0.29-0.006V40.604z M373.835,18.409
 l-0.606,0.017l-75.686,0.749c-0.065,0-6.391-0.187-8.899-3.925c3.181-0.656,22.893-4.549,51.627-6.565
 c28.764-2.018,72.683-2.51,118.761,6.576c-2.525,3.706-9.173,3.684-9.255,3.689L373.835,18.409z M374.163,153.129v-6.669
 c1.323-0.273,3.34,0.268,5.019,1.388c1.039,0.683,2.804,2.171,3.045,4.406c0.328,3.013-0.579,23.654-1.082,34.401
 C380.423,175.132,378.521,154.282,374.163,153.129 M381.511,193.757c-0.012-0.186-0.023-0.432-0.033-0.732
 c0.142-2.832,1.826-36.791,1.388-40.836c-0.197-1.854-1.378-3.58-3.323-4.876c-1.794-1.192-3.888-1.761-5.38-1.504V41.238
 c9.556-0.18,21.102-0.372,32.346-0.552c19.489,24.031,41.35,48.882,64.993,73.865c0.481,7.981,0.749,15.422,0.88,22.025
 c0.071,3.515,0.147,7.21,0.225,11.054l-41.929,0.459l0.24,27.354l-0.044,6.025h0.345c-0.082,14.875,0,34.188,0.065,48.347
 c0.028,6.297,0.049,11.458,0.049,14.536c0,0.082,0.033,0.164,0.093,0.223c0.06,0.061,0.142,0.099,0.229,0.099l43.083-0.257
 c0.038,1.979,0.077,3.942,0.116,5.894c-6.452,0.912-49.9,6.597-85.75-0.116c0.016-0.869,0.038-1.716,0.054-2.536
 C387.967,220.822,381.762,194.823,381.511,193.757 M473.694,381.667c-0.256,42.973-0.58,96.388-3.69,105.391
 c-2.399,0.7-32.39,8.938-72.066,0c-0.399-5.21-5.369-103.713-5.964-115.521c12.158,2.033,24.999,2.728,36.878,2.728
 c21.21,0,39.327-2.214,44.902-2.968C473.733,374.669,473.716,378.135,473.694,381.667 M474.837,326.88
 c-0.722,3.619-0.93,21.522-1.077,43.766c-8.512,1.159-47.899,5.937-81.819,0.235c-0.016-0.284-0.022-0.453-0.028-0.492
 c-0.032-0.842-3.454-82.157-2.82-119.544c12.95,2.416,26.874,3.22,39.693,3.22c22.621,0,41.786-2.504,46.078-3.111
 C475.586,289.221,475.898,321.572,474.837,326.88"
      />
      <path
        d="M107.377,42.851c-1.159,0-2.033,1.891-2.033,4.4c0,2.504,0.874,4.396,2.033,4.396s2.028-1.892,2.028-4.396
 C109.405,44.742,108.536,42.851,107.377,42.851z"
      />
      <path
        d="M381.472,25.133c-2.137,0-3.875,1.739-3.875,3.876c0,2.137,1.738,3.876,3.875,3.876c2.138,0,3.876-1.739,3.876-3.876
 C385.348,26.872,383.61,25.133,381.472,25.133z"
      />
      <path
        d="M397.106,25.133c-2.137,0-3.876,1.739-3.876,3.876c0,2.137,1.739,3.876,3.876,3.876c2.132,0,3.871-1.739,3.871-3.876
 C400.977,26.872,399.238,25.133,397.106,25.133z"
      />
    </svg>
  );
}
